import { recurrenceIntervalString } from '@frontend/api-client';
import type { Recurrence } from '@frontend/api-types';
import { dayjs } from '@frontend/duck-tape';
import { CardBadge, CardButton, CardContainer, CardContent, CardHeader, XStack, YStack } from '@frontend/web-react';
import { useNavigate } from '@tanstack/react-router';

type ReviewTaskCardProps = {
  recurrence: Recurrence;
};

export const ScheduledTaskCard = ({ recurrence }: ReviewTaskCardProps) => {
  const navigate = useNavigate();
  const { description, id, name, nextTaskDueDate } = recurrence;

  const navigateToRecurrence = () => {
    navigate({ to: `/app/recurrence/${id}` });
  };

  return (
    <CardContainer className="justify-between" noPadding onClick={navigateToRecurrence}>
      <YStack className="gap-md p-md">
        <CardHeader title={name} />
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-expect-error */}
        <CardContent description={description} descriptionTextProps={{ lineClamp: 2 }} />
        <XStack className="gap-sm grid grid-cols-2 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1">
          <XStack>
            <CardBadge
              containerClassName="bg-lime-100"
              iconColor="lime"
              leftIconName="IconCalendar"
              size="md"
              text={`Next: ${dayjs(nextTaskDueDate).format('M/D')}`}
              textClassName="text-lime-900"
            />
          </XStack>
          <XStack>
            <CardBadge
              containerClassName="bg-neutral-100"
              iconColor="neutral"
              leftIconName="IconRepeat"
              size="md"
              text={recurrenceIntervalString(recurrence)}
              textClassName="text-neutral-900"
            />
          </XStack>
        </XStack>
      </YStack>
      <YStack className="p-md items-end">
        <CardButton label="Go to task" onClick={navigateToRecurrence} variant="subtle" />
      </YStack>
    </CardContainer>
  );
};
